import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import { Chip } from "@mui/material";

type StatusType = "Aguardando pagamento" | "Pago";

interface SituacaProcessoChipProps {
    situacao: StatusType
}

export default function SituacaoPagamentoChip({ situacao }: SituacaProcessoChipProps) {

    switch(situacao){
        case 'Pago': return (<Chip label="Confirmado" variant="outlined" color="primary" icon={<DoneOutlinedIcon />} />)
        case 'Aguardando pagamento': return (<Chip label="Pendente" variant="outlined" color="warning" icon={<TimerOutlinedIcon />} />)
    }

    return <Chip label={situacao} variant="outlined" />
}
